const YOUTUBE_ID_RE = /^[a-zA-Z0-9_-]{3,20}$/;

const YOUTUBE_URL_PATTERNS: RegExp[] = [
  /(?:youtube\.com\/watch\?(?:[^#]*&)?v=)([a-zA-Z0-9_-]{3,20})/i,
  /youtu\.be\/([a-zA-Z0-9_-]{3,20})/i,
  /youtube\.com\/embed\/([a-zA-Z0-9_-]{3,20})/i,
  /youtube\.com\/shorts\/([a-zA-Z0-9_-]{3,20})/i,
  /youtube\.com\/live\/([a-zA-Z0-9_-]{3,20})/i,
  /youtube-nocookie\.com\/embed\/([a-zA-Z0-9_-]{3,20})/i,
];

/**
 * Extract a YouTube video ID from a watch/share/embed/shorts URL, or return
 * the string if it is already a plain ID. Vimeo and other hosts return null.
 */
export function extractYouTubeVideoId(value: string): string | null {
  const v = (value || '').trim();
  if (!v) return null;
  for (const pattern of YOUTUBE_URL_PATTERNS) {
    const match = v.match(pattern);
    const id = match?.[1];
    if (id && YOUTUBE_ID_RE.test(id)) return id;
  }
  if (YOUTUBE_ID_RE.test(v) && !v.includes('/') && !/^https?:/i.test(v)) {
    return v;
  }
  return null;
}
